
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {InvoiceProps} from "types/props-obj/InvoiceProps";
import exportFromJSON from 'export-from-json';

const initialState: InvoiceProps = {
    apiEndPoint: "invoice",
    pageLimit: 25,
    pageNumber: 1,
    isOpen: false,
    list: [],
  isAddedLastTotal:false,

    item: null,
    error: null,
    alertPopup: false,
    invoiceStats: [],
    invoiceData: {
        // current_page: 0,
        data: [],
        // first_page_url: "",
        // from: 0,
        last_page: 0,
        // last_page_url: "",
        // links: [],
        // next_page_url: "",
        // path: "",
        per_page: 0,
        // prev_page_url: "",
        // to: 0,
        total: 0
    },
    yearRange: { min_year: new Date().getFullYear(), max_year: new Date().getFullYear() },
};

const invoice = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {

            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
        },
        removeItem(state) {
            state.item =null;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total;
            
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
        },
       
        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.item=action.payload;
            state.list[foundIndex] = action.payload;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
        },
        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
        setInvoiceStatsSuccess(state, action) {
            state.invoiceStats = action.payload;
        },
        setInvoiceDataSuccess(state, action) {
            state.invoiceData = action.payload;
            state.isAddedLastTotal=false;
        }
        ,

         addItemSuccessToData(state, action) {
            state.invoiceData.data = [...state.invoiceData.data,action.payload];
            state.isAddedLastTotal=true;

        },

        setYearRange(state, action) {
            state.yearRange = action.payload;
        },
    }
});


export default invoice.reducer;

function getApiEndPoint(){
    return store.getState().invoice.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setPageLimit,setApiEndPoint,removeItem,addItemSuccess,addItemSuccessToData,setYearRange } = invoice.actions;
export function getList(params:any={}) {
    return async () => {
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(invoice.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(invoice.actions.hasError(error));
        }
    };
}
export function getInvoiceStats(year:string,interval:string) {
    return async () => {
        try {
            const response = await axios.get(`/invoice-stats/${year}/${interval}/invoice`);
            dispatch(invoice.actions.setInvoiceStatsSuccess(response.data));
        } catch (error) {
            dispatch(invoice.actions.hasError(error));
        }
    };
}
export function exportInvoices(from:string, to:string, fileName: string) {
    return async () => {
        try {
            // console.log(`query: export-invoice/${from}/${to}/invoice` )
            const response = await axios.get(`export-invoice/${from}/${to}/invoice`);
            // console.log("invoices: ", response.data)
            if(response?.data?.length < 1) return alert("No Invoices in this range")
            exportFromJSON({
                data: response.data,
                fileName,
                exportType: exportFromJSON.types.csv,
            });
        } catch (error) {
            dispatch(invoice.actions.hasError(error));
        }
    };
}
export function getYearRange() {
    return async () => {
        try {
            const response = await axios.get('invoice-year-range');
            dispatch(invoice.actions.setYearRange(response.data));
        } catch (error) {
            const currentYear = new Date().getFullYear();
            dispatch(invoice.actions.setYearRange({ min_year: currentYear, max_year: currentYear }));
        }
    };
}
export function getInvoiceData(params:{ page:number, limit:number,interval:string }, year:string,index:number) {
  return async () => {
    console.log(params);
    
    try {
        // params.limit??25;
      const response = await axios.get(`/invoice-accordion/${year}/${index}/invoice`, {params});
    
      dispatch(invoice.actions.setInvoiceDataSuccess(
       response.data
      ));
    } catch (error) {
      dispatch(invoice.actions.hasError(error));
    }
  };
}


export function getItem(id: number | undefined) {
    return async () => {
        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(invoice.actions.setItem(response.data));
        } catch (error) {
            dispatch(invoice.actions.hasError(error));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        try {
            const response = await axios.post(getApiEndPoint(), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(invoice.actions.addItemSuccess(response.data));
        } catch (error) {
            dispatch(invoice.actions.hasError(error));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(invoice.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(invoice.actions.hasError(error));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(invoice.actions.deleteItemSuccess(id));
        } catch (error) {
            dispatch(invoice.actions.hasError(error));
        }
    };
}
export function sendInvoice(id: number | undefined,ls: any) {
    return async () => {
      try {
        const response = await axios.post(['send-invoice',  id].join('/'), ls,{headers:{'Content-Type': 'multipart/form-data'}});
        dispatch(invoice.actions.editItemSuccess(response.data));
      } catch (error:any) {
        dispatch(invoice.actions.hasError(error));
        // dispatch(openSnackbar({open: true,message: error.message,variant: 'alert',alert: {color: 'error'},close: false}));
      }
    };
  }